// import utils
import { keyframes } from "@mui/material/styles";
export const MUIKeyframes = keyframes;
export default MUIKeyframes;
